module.exports = __webpack_public_path__ + "static/media/akagi.9b7fd894.png";